import { render, staticRenderFns } from "./RuleHistoryDialog.vue?vue&type=template&id=0778df04&scoped=true&"
import script from "./RuleHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./RuleHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./RuleHistoryDialog.vue?vue&type=style&index=0&id=0778df04&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778df04",
  null
  
)

export default component.exports